import Vue from 'vue';
import App from './App.vue';
import './plugins/bootstrap-vue.js';
import store from './store';
import router from './router';
import vSelect from 'vue-select';
import VueSweetalert2 from 'vue-sweetalert2';
import VueGoodTablePlugin from 'vue-good-table';
// import VueApexCharts from 'vue-apexcharts'
// import Dropzone from "dropzone";
import vue2Dropzone from 'vue2-dropzone';
import VueProgressBar from 'vue-progressbar';

import 'vue-select/dist/vue-select.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-good-table/dist/vue-good-table.css';
// dashkit themes
import './assets/css/libs.bundle.css';
import './assets/css/theme.bundle.css';
import 'vue2-timepicker/dist/VueTimepicker.css';
// import QrcodeVue from 'qrcode.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import VeeValidate from 'vee-validate';
//import Calendar from 'v-calendar/lib/components/calendar.umd'
//import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import VueQRCodeComponent from 'vue-qrcode-component';
import VueHtmlToPaper from 'vue-html-to-paper';
import Vue2Editor from 'vue2-editor';
import Keycloak from 'keycloak-js';
import VueTimepicker from 'vue2-timepicker';
import i18n from './i18n/i18n';

const options = {
	name: '_blank',
	specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
	styles: [
		'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
		'https://unpkg.com/kidlat-css/css/kidlat.css',
	],
	timeout: 1000, // default timeout before the print window appears
	autoClose: true, // if false, the window will not close after printing
	windowTitle: window.document.title, // override the window title
};

window.queryString = require('query-string');

Vue.use(VueSweetalert2);
Vue.use(VueGoodTablePlugin);
// Vue.use(VueApexCharts)
Vue.use(VeeValidate);
Vue.use(vue2Dropzone);
Vue.use(Vue2Editor);
Vue.use(VueHtmlToPaper, options);

Vue.use(VueProgressBar, {
	color: 'rgb(161, 37, 41)',
	failedColor: 'red',
	thickness: '7px',
});
//Vue.component('v-calendar', Calendar)
//Vue.component('v-date-picker', DatePicker)

Vue.component('v-select', vSelect);
Vue.component('v-checkbox', vSelect);
// Vue.component('apexchart', VueApexCharts)
Vue.component('qr-code', VueQRCodeComponent);
Vue.component('v-timepicker', VueTimepicker);

Vue.config.productionTip = false;

const kcOptions = {
	realm: 'ugems',
	'auth-server-url': process.env.VUE_APP_KEYCLOAK_URL,
	url: process.env.VUE_APP_KEYCLOAK_URL,
	'ssl-required': 'external',
	clientId: process.env.VUE_APP_KEYCLOAK_CLIENT,
	resource: process.env.VUE_APP_KEYCLOAK_CLIENT,
	'verify-token-audience': true,
	'use-resource-role-mappings': true,
	'confidential-port': 0,
	'policy-enforcer': {},
};

const keycloak = new Keycloak(kcOptions);

await keycloak
	.init({
		onLoad: 'login-required',
		checkLoginIframe: true,
		promiseType: 'native',
	})
	.then(async () => {
		Vue.prototype.$http.defaults.headers['Authorization'] = `Bearer ${keycloak.token}`;
		localStorage.setItem('ugems-accessToken', keycloak.token);
		localStorage.setItem('ugems-refreshToken', keycloak.refreshToken);
		localStorage.setItem('ugems-tokenParsed', JSON.stringify(keycloak.tokenParsed));
	})
	.catch((err) => {
		console.log('failed to authenticate', err);
		alert('Authentication failed. Please check your credentials and try again.');
	});

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
